import { render, staticRenderFns } from "./PopperModal.vue?vue&type=template&id=2f548bac&scoped=true&"
import script from "./PopperModal.vue?vue&type=script&lang=js&"
export * from "./PopperModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f548bac",
  null
  
)

export default component.exports